import MockupAdvancedView from './MockupAdvancedView'

export default MockupAdvancedView
